import tw, { styled } from 'twin.macro'

import type { BackButtonDisplayOptions } from './types'

export const Block = tw.div`space-y-2 font-brand`

export const Top = tw.div`flex items-center`

export const BackButton = styled.button<{ display?: BackButtonDisplayOptions }>(
  ({ display }) => [
    tw`mr-2 cursor-pointer hidden`,
    display === 'desktop' && tw`lg:block`,
    display === 'mobile' && tw`block lg:hidden `,
    display === 'any' && tw`block`,
  ],
)

export const Title = tw.div`
  text-default-emphasis
  text-lg-brand
  font-semibold
`

export const Subtitle = tw.div`
  text-default-muted
  text-sm-brand
`
